import type { GameManifest } from "../../contracts/game";

export const ticTacWhoaManifest: GameManifest = {
  id: "tic-tac-whoa",
  title: "Tic Tac Whoa",
  version: "0.1.0",
  status: "playable",
  coverAsset: "/covers/tic-tac-whoa.jpg",
  catalogOrder: 2,
  preferredAspectRatio: 16 / 9,
  supportsCpu: true,
  load: () => import("./index"),
};
